import VerificationCheckEmail from './VerificationCheckEmail';

export default VerificationCheckEmail;
